
import { Dropdown, Button, Space } from "antd";
import { useContext, useState } from "react";
import { FaChevronDown, FaRegFilePdf } from "react-icons/fa6";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { exportContext } from "../../context/ExportDataContext";
import { ClientReportExportContext } from "../../context/ClientReportExportContext";
import { useExportHandlers } from "../../utils/exportReportHandler";
import trans from "../../utils";
import { ExportReportPdfHandler } from "../../utils/exportReportPdfHandler";
import { useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ExportDropdown = () => {
  const [loading, setLoading] = useState(false);
  const { fileName, exportIds, startDateE, endDateE, filters } =
    useContext(exportContext);
  const { handlers: clientHandlers } = useContext(ClientReportExportContext);
  const { handleExportReport } = useExportHandlers();
  const { handleExportReportPdf } = ExportReportPdfHandler();
  const { pathname } = useLocation();
  const url = pathname.replace(/\/+$/, "").split("/").pop();

  const handleMenuClick = async ({ key }) => {
    if (clientHandlers) {
      if (key === "pdf") {
        await clientHandlers.exportPdf();
      } else if (key === "xlsx") {
        await clientHandlers.exportExcel();
      }
      return;
    }

    if (key === "pdf") {
      setLoading(true);
      try {
        await handleExportReportPdf({
          fileName,
          exportIds,
          startDate: startDateE,
          endDate: endDateE,
        });
      } catch (err) {
        console.error("Export failed", err);
      } finally {
        setLoading(false);
      }
    } else if (key === "xlsx") {
      setLoading(true);
      try {
        await handleExportReport({
          fileName,
          exportIds,
          startDate: startDateE,
          endDate: endDateE,
          filters,
        });
      } catch (err) {
        console.error("Export failed", err);
      } finally {
        setLoading(false);
      }
    }
  };

  const items = [
    {
      label: trans("Export PDF"),
      key: "pdf",
      icon: <FaRegFilePdf />,
    },
    {
      label: trans("Export XLSX"),
      key: "xlsx",
      icon: <PiMicrosoftExcelLogoFill />,
    },
  ];
  //      			disabled={!fileName || !exportIds || !startDateE || !endDateE || loading}

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick }}
      trigger={["hover"]}
      placement="bottomRight"
    >
      <Button
        className="outline-button"
        loading={loading || clientHandlers?.loading}
        disabled={clientHandlers?.loading}
      >
        {trans("Export Report")}
        <FaChevronDown />
      </Button>
    </Dropdown>
  );
};

export default ExportDropdown;

